import * as userActions from "./user";

export const ActionCreators = Object.assign({}, userActions);
